export default function CostComparisonSection() {
  const rows = [
    { service: "Fast Passport Center", type: "Registered Direct Courier", fee: "From $195", directCourier: "✓ Yes — Reserved daily agency slots", highlight: true },
    { service: "FedEx Office / RushMyPassport", type: "Reseller + Courier", fee: "$400–$700+", directCourier: "✗ No (reseller — no reserved slots)", highlight: false },
    { service: "Staples / PassportsAndVisas", type: "Reseller", fee: "$350–$650+", directCourier: "✗ No (reseller — no reserved slots)", highlight: false },
    { service: "Post Office (DIY Expedited)", type: "Self-service", fee: "$190 govt fee only", directCourier: "N/A — 3–4 weeks minimum, no reserved slots", highlight: false },
  ];

  return (
    <section id="cost-comparison" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Cost Comparison</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Why Fast Passport Center Costs Less —{" "}
            <span className="text-[#F6C344]">And Gets You In Faster</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Resellers charge you a markup and still have to hand your application to a courier anyway. Go direct and <strong className="text-[#1A365D]">get one of our limited daily agency drop-off slots</strong> — these are allotted in-restricted numbers by the State Department, are not available to the general public, and each one guarantees processing in a specified number of days.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white rounded-xl overflow-hidden shadow-sm">
            <thead>
              <tr className="bg-[#1A365D] text-white">
                <th className="text-left p-4 text-sm font-bold">Service</th>
                <th className="text-left p-4 text-sm font-bold hidden sm:table-cell">Type</th>
                <th className="text-left p-4 text-sm font-bold">Typical Service Fee</th>
                <th className="text-left p-4 text-sm font-bold hidden sm:table-cell">Direct Courier?</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr
                  key={i}
                  className={`border-b border-gray-100 ${row.highlight ? "bg-[#F6C344]/5" : ""}`}
                >
                  <td className={`p-4 text-sm ${row.highlight ? "font-bold text-[#1A365D]" : "text-gray-700"}`}>
                    {row.highlight && <i className="ri-check-double-line text-[#F6C344] mr-1.5"></i>}
                    {row.service}
                  </td>
                  <td className="p-4 text-sm text-gray-500 hidden sm:table-cell">{row.type}</td>
                  <td className={`p-4 text-sm ${row.highlight ? "font-bold text-[#0D7A5F]" : "text-gray-700"}`}>{row.fee}</td>
                  <td className={`p-4 text-sm hidden sm:table-cell ${row.highlight ? "font-bold text-[#0D7A5F]" : "text-gray-500"}`}>{row.directCourier}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 bg-[#1A365D]/5 border border-[#1A365D]/15 rounded-xl p-5">
          <h3 className="font-bold text-[#1A365D] text-sm mb-2 flex items-center gap-2">
            <i className="ri-key-2-line text-[#F6C344] text-lg"></i>
            Why Limited Daily Drop-Off Slots Matter
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-3">
            This isn't just someone standing in line. Under the U.S. Department of State's Hand Carry Program, authorized couriers like Fast Passport Center are <strong className="text-[#1A365D]">allotted a limited number of in-person drop-offs at regional passport agencies each day</strong>. Each drop-off is processed in a specified number of days — and these drop-off privileges are <strong className="text-[#1A365D]">not available to the general public</strong>. You cannot walk in. You cannot call for one. The only way to use one of these limited slots is through a registered, authorized courier.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            When you pay for expedited courier service, what you're really paying for is <strong className="text-[#1A365D]">access to one of these scarce daily drop-off slots</strong> — a finite resource that guarantees your application lands on an agency desk and gets processed within a known, predictable timeframe. That's the difference between getting your passport in 3 business days versus waiting 6+ weeks. FedEx, Staples, and other resellers don't have these slots at all — they're either mailing your application or handing it to someone like us anyway, after taking their cut.
          </p>
        </div>

        <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-4">
          <p className="text-gray-600 text-sm leading-relaxed">
            <strong className="text-[#1A365D]">Government fees are separate</strong> and required regardless of which service you use. Fast Passport Center's service fee covers expert document review, access to one of our limited daily agency drop-off slots (allotted by the State Department and not available to the public), and overnight return delivery. We do not mark up government fees.
          </p>
        </div>
      </div>
    </section>
  );
}